import { render, staticRenderFns } from "./ManageAccountingReport.vue?vue&type=template&id=490e889c"
import script from "./ManageAccountingReport.vue?vue&type=script&lang=js"
export * from "./ManageAccountingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports